import { module as BaseModule } from 'modujs'

/**
 * Quantity − / + stepper around WooCommerce `.qty` input.
 */
export default class extends BaseModule {
  init () {
    this.input = this.el.querySelector('.qty, .shop-qty__input, input[type="number"]')
    if (!this.input || this.input.readOnly) return

    this.onClick = this.onClick.bind(this)
    this.el.addEventListener('click', this.onClick)
  }

  destroy () {
    this.el.removeEventListener('click', this.onClick)
  }

  onClick (event) {
    const btn = event.target.closest('[data-qty]')
    if (!btn || !this.el.contains(btn)) return

    event.preventDefault()
    const dir = btn.getAttribute('data-qty')
    const step = parseFloat(this.input.step) || 1
    const min = this.input.min !== '' ? parseFloat(this.input.min) : 0
    const max = this.input.max !== '' ? parseFloat(this.input.max) : Infinity
    let value = parseFloat(this.input.value)
    if (Number.isNaN(value)) value = min

    if (dir === 'minus') value -= step
    if (dir === 'plus') value += step

    value = Math.min(max, Math.max(min, value))
    // Prefer integers when step is whole.
    if (step % 1 === 0) value = Math.round(value)

    this.input.value = String(value)
    this.input.dispatchEvent(new Event('change', { bubbles: true }))
    this.input.dispatchEvent(new Event('input', { bubbles: true }))
  }
}
